import { z } from "zod";

export const PersonRef = z.object({
  entraId: z.string().min(1),
  displayName: z.string().min(1),
  email: z.string().email(),
});
export type PersonRef = z.infer<typeof PersonRef>;

export const EntraGroupRef = z.object({ id: z.string().trim().min(1).max(200), displayName: z.string().trim().min(1).max(500) }).strict();
export type EntraGroupRef = z.infer<typeof EntraGroupRef>;
